import { Injectable, Injector } from '@angular/core';
import { tap } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';
import { BaseService } from '../../shared/_utils/services/base-service';
import { EmployeePayroll } from '../model/employee-payroll';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class EmployeePayrollService extends BaseService {

  uri = '/api/employeePayroll/';

  constructor(injector: Injector, spinnerService: SpinnerService) {
    super(injector);
  //  console.log('Instance EmployeePayrollService');
  }

  calculationPayroll(filenma:string,calculationPayroll: EmployeePayroll) {
    const url = `${this.rutaServidor}${this.uri}`;
    this.spinnerService.showAll();
    let params = new HttpParams()
    .set('filenma', filenma)

    return this.httpClient.post<EmployeePayroll>(url, calculationPayroll,{params})
      .pipe(
        tap(response => {
            this.spinnerService.hideAll();
        //  console.log('calculationPayroll', response);
        })
      );
    }
  }



// WEBPACK FOOTER //
// ./src/app/core/services/employee-payroll.service.ts